import { ThemeInterface } from '@westwing/ui-kit/Theme';
// eslint-disable-next-line no-restricted-imports
import { createGlobalStyle, ThemeProps } from 'styled-components';
import { TABLET, tillBreakpoint } from '../../../../mediaqueries';

interface BodyBlockerGlobalStyleProps extends ThemeProps<ThemeInterface> {
    withClassName?: string;
}
export const BodyBlockerGlobalStyle = createGlobalStyle<BodyBlockerGlobalStyleProps>`
    ${tillBreakpoint[TABLET]`
        body${(props: BodyBlockerGlobalStyleProps) => (props.withClassName ? `.${props.withClassName}` : '')} {
            background: white !important;
            overflow: hidden !important;
        }
  `}
`;
